<template>
  <div class="study">
    <a-spin :spinning="loading" style="width:100%;" size="large" tip="加载中...">
      <div class="card-list">
        <div style="width: 100%;display:flex;flex-direction:column;justify-content: center;align-items: center;" v-if="courseList && courseList.length === 0">
          <img
            :src="require('@/assets/icons/no_data@2x.png')"
            style="width: 150px"/>
          <div class="no-data-text">暂无数据</div>
        </div>
        <div
          @click="goToVideo(item)"
          :class="(index + 1) % 4 === 0 ? 'card-item' : 'card-item card-item-space'"
          :key="item.id"
          v-for="(item, index) in courseList"
          v-if="courseList && courseList.length > 0">
        <img
          :src="item.attachmentList&&item.attachmentList.length>0?baseUrl + item.attachmentList[0].url:''"
          class="card-item-img"/>
        <div class="card-item-message">
          <div class="card-item-name">{{ item.name }}</div>
          <!--              <div class="card-item-content">课程名称：{{ item.courseName }}</div>-->
          <div class="card-item-content">课程分类：{{ item.categoryName }}</div>
        </div>
        </div>
      </div>
      <a-pagination
        :current="currentPage"
        :pageSize="pageSize"
        :show-total="total => `共 ${total} 条`"
        :total="page.totalCount"
        @change="handlePageChange"
        class="pagination"
        v-if="courseList && courseList.length > 0"/>
    </a-spin>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import myCourse from '../../../api/myCourse'

  export default {
    name: 'study',
    components: {},
    data() {
      return {
        baseUrl: process.env.VUE_APP_BASE_URL,
        loading: true,
        courseList: undefined,
        currentPage: 1,
        pageSize: 12,
        page: { totalCount: '' }
      }
    },
    computed: {
      ...mapState({
        userData: state => {
          if (state.user.userData.name) {
            return state.user.userData
          } else {
            return JSON.parse(localStorage.getItem('user'))
          }
        }
      })
    },
    filters: {},
    methods: {
      loadData(pageNo) {
        const param = {
          wholeCourseId: sessionStorage.getItem('wholeCourseId')
        }
        this.loading = true
        const page = {
          pageNo: pageNo,
          pageSize: 12,
          sortField: '',
          draw: ''
        }
        myCourse.getCourseClassList(Object.assign(param, page)).then(res => {
          this.page = res.result.page
          this.courseList = res.result.list
          this.currentPage = this.page.pageNo
          setTimeout(() => {
            this.loading = false
          }, 500)
        })
      },
      handlePageChange(page) {
        this.loadData(page)
      },
      goToVideo(record) {
        sessionStorage.setItem('courseId', record.id)
        sessionStorage.setItem('isTry', '0')
        this.$router.push('/home/videoDetail')
      }
    },
    created() {
      this.loadData(1)
    }

  }
</script>
<style lang="less">
  .study {

    .card-list {
      text-align: start;
      width: 100%;
      min-height: 1.5rem;
      display: flex;
      flex-wrap: wrap;

      .card-item {
        width: 2.7151rem;
        margin-top: 0.18rem;
        background-color: white;
        border-radius: 0.0375rem;
        cursor: pointer;
        box-shadow: 0rem 0.0225rem 0.0225rem #c8c8c8;
        -webkit-box-shadow: 0rem 0.0225rem 0.0225rem #c8c8c8;
        -moz-box-shadow: 0rem 0.0225rem 0.0225rem #c8c8c8;
      }

      .card-item-space {
        margin-right: 0.15rem;
      }

      .card-item-message {
        padding: 0.1575rem 0.15rem 0.21rem 0.12rem;

        .card-item-name {
          height: 0.405rem;
          font-weight: 600;
          color: #191d28;
          font-size: 0.16rem;
          line-height: 0.2rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .card-item-content {
          color: #79818d;
          margin-top: 0.12rem;
          font-size: 0.1275rem;
          line-height: 0.18rem;
        }

        .card-item-hour {
          color: #f16695;
        }
      }

      .card-item-img {
        width: 2.7226rem;
        height: 1.53rem;
        border-top-left-radius: 0.0375rem;
        border-top-right-radius: 0.0375rem;
        object-fit: cover;
      }

    }

    .pagination {
      margin-top: 0.18rem;
      text-align: end;
    }
  }
</style>
